import { permitir_realizar_carga_de_codigo_inep } from "./permitir-realizar-carga-de-codigo-inep/index";
import { gerar_arquivo_texto_de_docentes_sem_codigo_inep } from "./gerar-arquivo-texto-de-docentes-sem-codigo-inep/index";
import { gerar_arquivo_texto_de_alunos_sem_codigo_inep } from "./gerar-arquivo-texto-de-alunos-sem-codigo-inep/index";

const codigo_inep = [
  ...permitir_realizar_carga_de_codigo_inep,
  ...gerar_arquivo_texto_de_docentes_sem_codigo_inep,
  ...gerar_arquivo_texto_de_alunos_sem_codigo_inep,
];

export { codigo_inep };
